
  import Vue from 'vue'
  import FilterChipTemplate from './FilterChipTemplate.vue';
  import PropertyService from '@/services/PropertyService';
  import { autoComplete } from '@/utils/Util';

  export default Vue.extend({
    name: 'PropertyFilter',

    components: {
      FilterChipTemplate
    },
    props: ['value', 'label', 'attributes', 'mandatory', 'always', 'multi', 'small'],
    data: (_this: any): any => ({
      rules: [
        (v: any) => !!v || _this.requiredError
      ],
      localProperty: _this.value[_this.attributes['value']],
      localFilters: _this.value as any,
      localTenantId: _this.$root.$store.state.session.selectedTenant.uuid,
      menu: false,
      loading: false,
      properties: [],
    }),
    created() {
      this.getProperties();
    },
    methods: {
      onSave() {
        this.localFilters[this.attributes['value']] = this.localProperty;
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onReset() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onChipRemove() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.$emit('delete');
      },
      autoComplete,
      getProperties() {
        this.properties = [];
        this.loading = true;
        
        PropertyService.getAllCollectionPages(this.localTenantId).then((properties: any[]) => {
            this.loading = false;

            this.properties = properties;
        }).catch((err: any) => {
            console.log(err, err.response); 
            this.loading = false;     
        });
      },
    },
    watch: {
      value() {
        this.localFilters = { ...this.value };
        this.localProperty = this.localFilters[this.attributes['value']];

        if('tenant' in this.localFilters && this.localFilters.tenant !== this.localTenantId) {
          this.localTenantId = this.localFilters.tenant;
          this.$delete(this.localFilters, this.attributes['value']);
          this.$emit('input', { ...this.localFilters });
          this.getProperties();
        }
      },
      menu() {
        if(!this.menu) {
          this.localProperty = this.localFilters[this.attributes['value']];
        }
      },
      currentTenant() {
        this.localTenantId = this.currentTenant;
        this.properties = [];
        this.localFilters = { ...this.value }; // TODO
        this.getProperties();
      }
    },
    computed: {
      isValid(): any {
        return this.mandatory ? this.rules.reduce((acc: boolean, rule: any) => acc ? rule(this.localProperty)===true : acc, true) : true;
      },
      requiredError(): any {
        return this.$t('required');
      },
      filterRepr(): any {
        const raw = this.localFilters[this.attributes['value']];
        if (!raw) return '';
        if(this.multi) {
          return (raw as any[]).map((uuid: any) => {
            const found = this.properties.find((p: any) => p.uuid === uuid);
            return found ? found.name : uuid;
          }).join(', ');
        }
        const found = this.properties.find((p: any) => p.uuid === raw);
        return found ? found.name : raw;
      },
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
    }
  })
